import {
    createSlice,
    createAsyncThunk
} from '@reduxjs/toolkit'
import { client } from '../../api/client'

export const version = createAsyncThunk(
    'version',
    async () => {
        const response = await client.post('/Version')
        return response.data
    }
)

// Slice
const sliceVersion = createSlice({
    name: 'version',
    initialState: {},
    reducers: {},
    extraReducers: {
        [version.pending]: (state, action) => {
            state.status = 'loading'
            state = undefined
        },
        [version.fulfilled]: (state, action) => {
            state.status = 'succeeded'
            state.version = action.payload
        },
        [version.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.payload
        }        
    }
})
export default sliceVersion.reducer